var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76528 21.9996C1.693 21.9996 0 20.3569 0 18.3448C0 16.3535 1.693 14.7275 3.76528 14.7275C5.83755 14.7275 7.53054 16.3514 7.53054 18.3448C7.50998 20.3757 5.83755 21.9996 3.76528 21.9996ZM3.76528 16.6228C2.76912 16.6228 1.9329 17.3972 1.9329 18.3448C1.9329 19.3321 2.73028 20.1232 3.76528 20.1232C4.78199 20.1232 5.59764 19.3488 5.59764 18.3448C5.57937 17.3972 4.76143 16.6228 3.76528 16.6228Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41054 19.0776C5.79366 19.0776 5.29102 18.6184 5.29102 18.0548V5.78156C5.29102 5.21799 5.79366 4.75879 6.41054 4.75879C7.02743 4.75879 7.53007 5.21799 7.53007 5.78156V18.0548C7.50722 18.6184 7.02743 19.0776 6.41054 19.0776Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3074 19.4489C13.2762 19.4489 11.6152 17.7561 11.6152 15.6834C11.6152 13.6108 13.2762 11.918 15.3074 11.918C17.3385 11.918 18.9995 13.6108 18.9995 15.6834C18.979 17.7561 17.3385 19.4489 15.3074 19.4489ZM15.3074 13.8508C14.3295 13.8508 13.5093 14.6878 13.5093 15.6834C13.5093 16.6791 14.3295 17.5161 15.3074 17.5161C16.2853 17.5161 17.1055 16.6791 17.1055 15.6834C17.0849 14.6878 16.2647 13.8508 15.3074 13.8508Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8803 16.4061C17.2634 16.4061 16.7607 15.9469 16.7607 15.3833V1.02277C16.7607 0.459202 17.2634 0 17.8803 0C18.4972 0 18.9998 0.459202 18.9998 1.02277V15.3833C18.9769 15.9469 18.4972 16.4061 17.8803 16.4061Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41064 6.8051C5.99939 6.8051 5.58813 6.5755 5.40535 6.19979C5.15403 5.69884 5.40535 5.09352 5.95369 4.86392L17.4232 0.104912C17.9715 -0.124689 18.6341 0.104911 18.8854 0.60586C19.1367 1.10681 18.8854 1.71212 18.3371 1.94172L6.86759 6.72161C6.70766 6.78423 6.57057 6.8051 6.41064 6.8051Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21C4.88072 21 6 19.8807 6 18.5C6 17.1193 4.88072 16 3.5 16C2.11929 16 1 17.1193 1 18.5C1 19.8807 2.11929 21 3.5 21Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18C16.8807 18 18 16.8807 18 15.5C18 14.1193 16.8807 13 15.5 13C14.1193 13 13 14.1193 13 15.5C13 16.8807 14.1193 18 15.5 18Z",
    fill: "#848484"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music-icon.3783f4f307fdac5b0a3012324f4d8581.svg";
export { ForwardRef as ReactComponent };